var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    fill: "#F8EEDF",
    stroke: "#E9E0D3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16075_40150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9993 14.667C35.3593 14.667 41.3327 20.6403 41.3327 28.0003C41.3327 35.3603 35.3593 41.3337 27.9993 41.3337C20.6393 41.3337 14.666 35.3603 14.666 28.0003C14.666 20.6403 20.6393 14.667 27.9993 14.667ZM20.03 32.555C21.9873 35.475 24.926 37.3337 28.2127 37.3337C31.498 37.3337 34.438 35.4763 36.394 32.555C34.175 30.4811 31.2499 29.3294 28.2127 29.3337C25.175 29.3291 22.2494 30.4808 20.03 32.555ZM27.9993 26.667C29.0602 26.667 30.0776 26.2456 30.8278 25.4954C31.5779 24.7453 31.9993 23.7279 31.9993 22.667C31.9993 21.6061 31.5779 20.5887 30.8278 19.8386C30.0776 19.0884 29.0602 18.667 27.9993 18.667C26.9385 18.667 25.9211 19.0884 25.1709 19.8386C24.4208 20.5887 23.9993 21.6061 23.9993 22.667C23.9993 23.7279 24.4208 24.7453 25.1709 25.4954C25.9211 26.2456 26.9385 26.667 27.9993 26.667Z",
    fill: "#B17F34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16075_40150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/userAvatar.2510cf68f535d84d8965d4fd52519a55.svg";
export { ForwardRef as ReactComponent };